module.exports = __webpack_public_path__ + "static/media/sonicstop-4.249af6f3.jpg";